import IRoute from '../interfaces/route';
import HomePage from '../components/home'
import CapabilitiesPage from '../components/capabilities';
import ContactPage from '../components/contact';
import WhyKeyes2SafetyPage from '../components/why-keyes2safety';

export const pages = {
    home: '/',
    capabilities: '/capabilities',
    contact: '/contact',
    whyKeyes2Safety: '/why-keyes-2-safety'
}

const routes: IRoute[] = [
    {
        path: pages.home,
        name: "Home",
        component: HomePage,
        exact: true
    },
    {
        path: pages.capabilities,
        name: "Capabilities",
        component: CapabilitiesPage,
        exact: true
    },
    {
        path: pages.contact,
        name: "Contact",
        component: ContactPage,
        exact: true
    },
    {
        path: pages.whyKeyes2Safety,
        name: "Why Keyes2Safety?",
        component: WhyKeyes2SafetyPage,
        exact: true
    }
]

export default routes;